import { S as o, N as s, P as l, T as a } from './thumbs.chunk.js';
const i = document.querySelector('[data-sticky-atc-show]'),
  e = document.querySelector('.js-sticky-btn');
let u = { rootMargin: '-54px 0px 0px 0px' };
const d = (t, b) => {
    t.forEach((c) => {
      c.isIntersecting
        ? e.classList.add('jc-opacity-0', 'jc-invisible')
        : (e.classList.remove('jc-opacity-0', 'jc-invisible'),
          window.addEventListener('resize', () => {
            e.style.top = document.querySelector('header').offsetHeight + 'px';
          }));
    });
  },
  p = new IntersectionObserver(d, u);
i &&
  ((e.style.top = document.querySelector('header').offsetHeight + 'px'),
  p.observe(i));
let n = new o('#productMainSliderThumbs', {
  spaceBetween: 16,
  slidesPerView: 4,
  freeMode: !0,
  watchSlidesProgress: !0,
  direction: 'vertical',
  on: {
    init: function () {
      document.querySelector('#productMainSliderThumbs').style.display =
        'block';
    },
  },
});
n.initialized
  ? (document.querySelector('#productMainSliderThumbs').style.display = 'block')
  : (document.querySelector('#productMainSliderThumbs').style.display = 'none');
new o('#productMainSlider', {
  modules: [s, l, a],
  navigation: {
    nextEl: '.swiper-button-next.productMainSlider-swiper-button-next',
    prevEl: '.swiper-button-prev.productMainSlider-swiper-button-prev',
  },
  pagination: {
    el: '.swiper-pagination.productMainSlider-swiper-pagination',
    clickable: !0,
  },
  thumbs: {
    swiper: document.querySelector('#productMainSliderThumbs') ? n : null,
  },
});
var r;
(r = document.querySelector('.jc-bis-button')) == null ||
  r.addEventListener('click', (t) => {
    t.preventDefault(), document.querySelector('.BIS_trigger').click();
  });
